import zh from '../locales/zh.js';

const en = {
  browse: 'Browse',
  'recently-viewed': 'Recently Viewed',
  inspect: 'Inspect',
  create: 'Create',
  search: 'Search',
  'openmct-search': 'OpenMCT Search',
  save: 'Save',
  cancel: 'Cancel',
  edit: 'Edit',
  close: 'Close',
  'open-new-tab': 'Open in new browser tab',
  'fullscreen-enable': 'Enable Fullscreen Mode',
  'fullscreen-exit': 'Exit Fullscreen Mode',
  'tree-collapse-all': 'Collapse All Tree Items',
  'tree-show-selected': 'Show selected item in tree',
  'clear-recently-viewed': 'Clear Recently Viewed',
  'time-conductor': 'Global Time Conductor',
  'show-icon-only': 'Show Icon Only',
  'show-icon-and-name': 'Show Icon and Name',
  'display-as-single-line': 'Display as Single Line',
  'display-as-multiple-lines': 'Display as Multiple Lines',
  searching: 'Searching...',
  'no-results-found': 'No results found',
  'no-items': 'No items',
  loading: 'Loading...',
  'create-modal-tree': 'Create Modal Tree',
  'main-tree': 'Main Tree',
  'browse-bar': 'Browse Bar',
  'nav-up-parent': 'Navigate up to parent',
  'browse-bar-object-name': 'Browse bar object name',
  'locked-for-editing-by': 'Locked for editing by {0}',
  'locked-for-editing': 'Locked for editing',
  'click-to-unlock': 'Click to unlock',
  'unlocked-for-editing': 'Unlocked for editing. Click to lock',
  'locked-cannot-unlock': 'Locked for editing, cannot unlock',
  'edit-object': 'Edit object',
  'save-finish': 'Save and Finish Editing',
  'save-continue': 'Save and Continue Editing',
  'cancel-editing': 'Cancel Editing',
  'more-actions': 'More actions',
  'unsaved-changes-lost': 'All unsaved changes will be lost. Are you sure you want to continue?',
  ok: 'Ok',
  'saving-do-not-navigate':
    'Saving. Do not navigate away from this page or close this browser tab.',
  saving: 'Saving',
  'save-successful': 'Save successful',
  'save-error': 'Error saving object',
  'fields-marked-required': 'All fields marked {0} are required.'
};

function getTranslations() {
  if (globalThis.__karma__) {
    return en;
  }

  const language = globalThis.navigator?.language || '';

  return language.toLowerCase().startsWith('zh') ? zh : en;
}

export function t(key, args) {
  let translation = getTranslations()[key] || en[key] || key;
  if (args) {
    if (Array.isArray(args)) {
      args.forEach((arg, index) => {
        translation = translation.replace(`{${index}}`, arg);
      });
    } else if (typeof args === 'object') {
      Object.keys(args).forEach((k) => {
        translation = translation.replace(`{${k}}`, args[k]);
      });
    }
  }

  return translation;
}

export default {
  install(app) {
    app.config.globalProperties.$t = t;
  }
};
